module.exports = __webpack_public_path__ + "static/blog-03-f469a140501634f112d48c5fa398173f.jpg";